module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"country-selector-error":"Выберите страну","phone-number-label":"Введите значение","example":"Пример:"},"en":{"country-selector-error":"Choose your country","phone-number-label":"Enter value","example":"Example:"}}')
  delete Component.options._Ctor
}
